import { render } from "./TestComponent.vue?vue&type=template&id=a235efb8&scoped=true"
import script from "./TestComponent.vue?vue&type=script&lang=js"
export * from "./TestComponent.vue?vue&type=script&lang=js"

import "./TestComponent.vue?vue&type=style&index=0&id=a235efb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a235efb8"]])

export default __exports__